"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSettingsParam = exports.createSettingsParams = void 0;
var tslib_1 = require("tslib");
var isLongKey = function (key) { return key.length > 20; };
function createSettingsParams(settings) {
    var keys = Object.keys(settings);
    if (process.env.NODE_ENV === 'development') {
        var longKeys = keys.filter(function (key) { return isLongKey(settings[key].key || key); });
        if (longKeys.length) {
            console.warn("Seems like you are trying to create settings params using long keys (more than 20 characters). This can cause the Public Data size limitation. Please consider renaming keys " + longKeys.join(', ') + ".");
        }
    }
    return keys.reduce(function (acc, key) {
        acc[key] = tslib_1.__assign(tslib_1.__assign({}, settings[key]), { key: settings[key].key || key });
        return acc;
    }, {});
}
exports.createSettingsParams = createSettingsParams;
exports.createSettingsParam = function (key, param) { return (tslib_1.__assign({ key: key }, param)); };
//# sourceMappingURL=createSettingsParams.js.map